import { useEffect, useState } from 'react';
import { Modal } from '@/shared/ui/Modal';
import { devRequestApi } from '@/features/project-board/api';
import { DevRequestSummaryRow } from '@/features/project-board/components/DevRequestSummaryRow';
import type { DevRequest, DevRequestSpecLink } from '@/features/project-board/types';

export class DevRequestPicker {

  static matches(request: DevRequest, query: string): boolean {
    return `${request.id} ${request.title} ${request.requester}`.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
  }

  static count(id: number, specs: DevRequestSpecLink[]): number { return specs.filter((spec) => spec.devRequestId === id).length; }
}

export function DevRequestPickerDialog(
  { onPick, onClose, initial }: { onPick: (id: number) => void; onClose: () => void; initial?: { requests: DevRequest[]; specs: DevRequestSpecLink[] } | null }
): React.JSX.Element {
  const [payload, setPayload] = useState<{ requests: DevRequest[]; specs: DevRequestSpecLink[] } | null>(initial ?? null);
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');
  useEffect(
    () => {
      let active = true;
      devRequestApi.list().then((value) => { if (active) setPayload(value); }).catch(
        (cause: unknown) => {
          if (active) setError(cause instanceof Error ? cause.message : String(cause));
        },
      );
      return () => { active = false; };
    },
    [],
  );
  return (
    <Modal
      open
      title="기존 요청서에 연결"
      onClose={onClose}
    >
      <input
        aria-label="요청서 검색"
        placeholder="번호·제목·요청자 검색"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        className="my-3 w-full rounded border border-line p-2 text-xs"
      />
      {error && <p role="alert" className="text-rose-700">{error}</p>}
      {!payload && !error && <p>불러오는 중…</p>}
      <ul className="max-h-96 space-y-2 overflow-y-auto">{payload?.requests.filter((request) => DevRequestPicker.matches(request, query)).map(
        (request) => <li key={request.id}>
          <button
            type="button"
            className="w-full rounded border border-line p-2 text-left text-xs hover:bg-canvas"
            onClick={() => onPick(request.id)}
          >
            <DevRequestSummaryRow request={request} specCount={DevRequestPicker.count(request.id, payload.specs)} /></button></li>,
      )}</ul>
    </Modal>
  );
}
